import {
  CreatePracticeChartFields,
  PracticeChartSortLabelType,
} from 'types/form/practiceChart';
import { TChartFileInfoList } from 'types/chart';
import { TPagingResponse } from '../api';

export type TCreatePracticeChartRequest = {
  [CreatePracticeChartFields.ChartTypeNum]: number;
  [CreatePracticeChartFields.ChartName]: string;
};

export type TPracticeChartListParams = {
  page: number;
  size: number;
  searchWord?: string;
  chartType?: number;
  lastModifiedAt?: string;
  sortBy?: PracticeChartSortLabelType;
  isAsc?: boolean;
};

export type TPracticeChartTableInfo = {
  practiceChartId: number;
  chartType: string;
  chartName: string;
  lastModifiedAt: string;
};

export type TPracticeChartList = {
  practiceChartList: TPracticeChartTableInfo[];
};

export type TPracticeChartListResponse = TPagingResponse<TPracticeChartList>;

export type TPracticeChartInfo = {
  chartData: object;
  fileInfoList: TChartFileInfoList[];
};

export type TPracticeChartInfoResponse = {
  chartName: string;
  chartInfo: TPracticeChartInfo;
};

export type TChartTypeInfo = {
  chartTypeNo: number;
  chartTypeName: string;
};

export enum PracticeChartTableHeader {
  PracticeChartId = 'practiceChartId',
  ChartType = 'chartType',
  ChartName = 'chartName',
  LastModifiedAt = 'lastModifiedAt',
}

export enum PracticeChartTableSortingLabel {
  ChartName = '차트명',
  LastModifiedAt = '최종 작성일',
}

export type TChangePracticeChartParams = {
  newChartName: string;
};

export type TTool = 'pen' | 'eraser';
